<template>
  <b-col cols="8" class="mx-auto">
    <div class="login-card">

             <div class="flex justify-center">
            <div class="">
              <div class="text-blue text-2xl font-bold">
                URSB
              </div>
            </div>
          </div>
      
      <h2 class="text-2xl font-bold tracking-tight text-center mb-1 text-blue">eRegistry Backoffice</h2>
      
      <!-- Animated Top Divider -->
      <div class="divider-line mx-auto mb-6"></div>

      <!-- Instruction description -->
      <p class="text-sm text-center mb-6" style="color: #64748b;">
        Enter your account's staff email address to request a password reset.
      </p>

      <!-- Alert message -->
      <div v-if="errorMessage != null" class="alert-custom">
        <i class="fa fa-times-circle text-lg flex-shrink-0"></i>
        <span class="text-sm font-medium">
          {{ errorMessage }}
        </span>
      </div>

      <form @submit.prevent="onResetPasswordSubmit" class="space-y-5">
        <!-- Staff Email input -->
        <div class="space-y-1.5">
          <label class="text-xs font-semibold" style="color: #64748b;">Staff Email</label>
          <div class="input-group-custom">
            <i class="fas fa-envelope input-icon"></i>
            <input
                v-model="form.emailAddress"
                type="email"
                class="input-field-custom"
                placeholder="Enter your staff email"
                required/>
          </div>
        </div>

        <!-- Submit button -->
        <div class="pt-2">
          <button class="btn-primary-custom" type="submit">
            <span>Reset Password</span>
            <b-spinner v-if="loading" small class="ml-2"></b-spinner>
          </button>
        </div>

        <!-- Go back link -->
        <div class="text-center pt-2">
          <span class="text-xs" style="color: #64748b;">You can go back to </span>
          <router-link
              class="text-xs font-semibold text-blue-custom"
              :to="{ name: 'login' }">
            Login
          </router-link>
        </div>
      </form>
    </div>
  </b-col>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "PasswordReset",
  data() {
    return {
      show1: false,
      errorMessage:null,
      form: {
        emailAddress: null
      },
      loading: false,
      loginTextInput:"flex-shrink flex-grow flex-auto leading-normal h-6  flex-1 self-center relative  font-roboto sm:text-sm outline-none",
    }
  },
  methods:{
    ...mapActions([
        "requestResetCode"
    ]),
    onResetPasswordSubmit(){
      this.loading = true
      this.errorMessage = null
      this.requestResetCode(this.form)
    }
  },
  computed: {
    ...mapGetters(["getRequestPassword", "getLoginError"])
  },
  watch: {
    getRequestPassword(data) {
      if(data){
        this.loading = false
        this.form = {
          email: null
        }

        let r = this.$router.resolve({
          name: "success-reset-password",
        });
        window.location.assign(r.href);

        this.successToast("Success", data.message)
      }
    },
    getLoginError(data){
      if(data){
        this.loading = false
        this.errorMessage = data.message
        this.errorToast("Error", data.message)
      }
    }
  }
}
</script>

<style scoped>
.login-card {
  background-color: #ffffff;
  border-radius: 1.25rem;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.05), 0 8px 10px -6px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.05);
  padding: 2.5rem 2.25rem;
  border: 1px solid #f1f5f9;
}

.logo-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 50%;
  background-color: rgba(0, 122, 197, 0.08);
  margin-bottom: 1.25rem;
}

.logo-circle {
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.divider-line {
  width: 3rem;
  height: 3px;
  background-color: #007ac5;
  border-radius: 9999px;
}

.alert-custom {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.875rem 1rem;
  border-radius: 0.625rem;
  border: 1px solid #fee2e2;
  background-color: #fef2f2;
  color: #b91c1c;
  text-align: left;
  margin-bottom: 1.5rem;
}

.input-group-custom {
  display: flex;
  align-items: center;
  border: 1px solid #e2e8f0;
  border-radius: 0.625rem;
  background-color: #ffffff;
  padding: 0.625rem 0.875rem;
  transition: all 0.2s ease-in-out;
}

.input-group-custom:focus-within {
  border-color: #007ac5;
  box-shadow: 0 0 0 3px rgba(0, 122, 197, 0.12);
}

.input-icon {
  color: #94a3b8;
  margin-right: 0.75rem;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
}

.input-field-custom {
  flex: 1;
  border: none;
  outline: none;
  font-size: 0.875rem;
  color: #1e293b;
  background-color: transparent;
  height: 1.5rem;
}

.input-field-custom::placeholder {
  color: #94a3b8;
}

.text-blue-custom {
  color: #007ac5;
  text-decoration: none;
  transition: color 0.15s ease-in-out;
}

.text-blue-custom:hover {
  color: #005a91;
  text-decoration: underline;
}

.btn-primary-custom {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.75rem 1rem;
  font-weight: 600;
  font-size: 0.875rem;
  border-radius: 0.625rem;
  color: #ffffff;
  background-color: #007ac5;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  outline: none;
}

.btn-primary-custom:hover {
  background-color: #0064a2;
  box-shadow: 0 4px 12px rgba(0, 122, 197, 0.15);
}

.btn-primary-custom:active {
  transform: scale(0.99);
}
</style>